export const calculateTotalPages = ({
  totalItems,
  limitPerPage,
}: {
  totalItems: number;
  limitPerPage: number;
}): number => {
  return Math.ceil(totalItems / limitPerPage);
};
